import * as React from "react";
import { useState } from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";

export const SearchResultsHeader = ({ settings }) => {
  const [resultsTotal, setResultsTotal]: any = useState<number | null>(null);
  const [query, setQuery] = useState<string | null>(null);
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

  const { heading_type_desktop, heading_type_mobile } =
    settings.section_settings;

  const CustomTagDesktop = heading_type_desktop as keyof JSX.IntrinsicElements;
  const CustomTagMobile = heading_type_mobile as keyof JSX.IntrinsicElements;

  React.useEffect(() => {
    const handleResults = (event) => {
      if (event.detail.type === "search") {
        setResultsTotal(event.detail.totalResults);
        setQuery(event.detail.query.replaceAll('"', ""));
      }
    };

    window.addEventListener("product-list", handleResults);

    // Cleanup the event listeners on component unmount
    return () => {
      window.removeEventListener("product-list", handleResults);
    };
  }, []);

  // Conditionally render content only if query is present
  if (!query && resultsTotal <= 0) {
    return null; // or return some loading state
  }

  return (
    <div
      className={`flex flex-col text-center h-full
        justify-${settings.section_settings.content_vertical_position_mobile}
        lg:justify-${settings.section_settings.content_vertical_position_desktop}
      `}
    >
      <div className="search-header__title text-left flex flex-col lg:w-1/2 w-full">
        <h2 className="mb-6 hidden lg:block">
          {`${resultsTotal > 0 ? 'Search' : 'No'} results for ‘${query}‘`}
        </h2>

        <h4 className="mb-6 lg:hidden">
          {`${resultsTotal > 0 ? 'Search' : 'No'} results for ‘${query}‘`}
        </h4>

        <p className="py-2">
          We found <span className="font-bold">{resultsTotal} results</span> for <span className="font-bold">‘{query}‘</span>
        </p>

        <div className="py-3 max-w-[493px]">
          <Paragraph
            text={`Explore our full range of eco-friendly products, designed to help you live a greener, more sustainable life. From refillable household essentials to reusable everyday items, we've got everything you need to reduce waste and make a positive impact on the environment.`}
            type={`text-xs lg:text-sm font-light lg:py-3`}
            maxChars={140}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchResultsHeader;
